export const LOAD_ALL_FONTS = 'LOAD_ALL_FONTS';
export const LOAD_ALL_FONTS_SUCCESS = 'LOAD_ALL_FONTS_SUCCESS';

export const loadAllFonts = scribe => ({
  type: LOAD_ALL_FONTS,
  scribe
});

export const loadAllFontsSuccess = () => ({
  type: LOAD_ALL_FONTS_SUCCESS
});
